import { useContext } from "react";

import { ErrorBoundaryContext } from "@lib/ErrorBoundaryContext";
import type { ErrorBoundaryContextType } from "@lib/ErrorBoundaryContext";

const defaultErrorBoundaryContext: ErrorBoundaryContextType = {
  triggerFailure: () => {},
  logException: () => {},
};

/**
 * Returns the error boundary context which can be used to trip the error
 * boundary or log exceptions using the error boundary outside of the render
 * cycle (i.e. in callbacks).
 */
export const useErrorBoundary = (): ErrorBoundaryContextType => {
  const context = useContext(ErrorBoundaryContext);
  return context || defaultErrorBoundaryContext;
};
